import React from 'react';

interface Props {
  children: React.ReactNode;
}

export const ClientFilterTitle = ({ children }: Props) => (
  <h3 className="text-base font-semibold uppercase tracking-wider">
    {children}
  </h3>
);
